import { render } from "./LinkInsert.vue?vue&type=template&id=c5d8dea2&scoped=true"
import script from "./LinkInsert.vue?vue&type=script&lang=js"
export * from "./LinkInsert.vue?vue&type=script&lang=js"

import "./LinkInsert.vue?vue&type=style&index=0&id=c5d8dea2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d8dea2"]])

export default __exports__